
import React, { useState } from "react";
import "./CartPage.css";
import { Socks } from "../../Assests/Assests";

const CartPage = () => {
    const [loading, setLoading] = useState(false); // Loader state
  
  const cartItems = [
    {
      id: 1,
      name: "Relaxed Fit T-shirt",
      price: 12.99,
      stockStatus: "In Stock",
      size: "XL",
      color: "Blue",
      quantity: 1,
      image: Socks,
    },
    {
      id: 2,
      name: "Nylon Sports Cap",
      price: 14.99,
      stockStatus: "Available in 2 days",
      size: "-",
      color: "-",
      quantity: 1,
      image: "path/to/image2.jpg",
    },
    {
      id: 3,
      name: "Sneakers",
      price: 34.99,
      stockStatus: "Out in stock",
      size: "UK 9",
      color: "-",
      quantity: 1,
      image: "path/to/image3.jpg",
    },
    {
      id: 4,
      name: "Slim Fit Suit Vest",
      price: 17.99,
      stockStatus: "In Stock",
      size: "XL",
      color: "Yellow",
      quantity: 1,
      image: "path/to/image4.jpg",
    },
  ];

  return (
    <div className="cart-container-new">
      <div className="cart-items-new">
        <h1 className="cart-title-new">Cart</h1>
        {cartItems.map((item) => (
          <div className="cart-item-new" key={item.id}>
            <div className="item-image-new">
              <img src={item.image} alt={item.name} />
            </div>
            <div className="item-details-new">
              <h3 className="item-name">{item.name}</h3>
              <p className="item-price">${item.price}</p>
              <p className={`item-stock ${item.stockStatus === "In Stock" ? "in-stock" : "out-stock"}`}>
                {item.stockStatus}
              </p>
              <div className="item-options-new">
                <span>Size: </span>
              <select>
                <option> {item.size}</option>
              </select>
              <span>Color:</span>
               <select>
                <option>{item.color}</option>
              </select>
              <span>Qun:</span>
               <select>
                <option>{item.quantity}</option>
              </select>
                {/* <p>Size: {item.size}</p> */}
               
                {/* <div className="items-increase-buttons"> <button>-</button>
                  <p></p>
                  <button>+</button></div> */}
              </div>
            </div>
            {/* <div className="item-action-new">
              <button>Save</button>
              <button>Delete</button>
            </div> */}
          </div>
        ))}
      </div>
      <div className="cart-summary-new">
        <h2>Delivery</h2>
        <div className="delivery-options">
          {/* <button>Free</button>
          <button>Express: $9.99</button> */}
        </div>
        <p>Delivery date: June 24, 2022</p>
        <input type="text" placeholder="Promocode" />
        <button>Apply</button>
        <div className="summary-details-new">
          <p>Subtotal: 8096</p>
          <p>Discount (20%): -1619</p>
          <p>Delivery: 00.00</p>
          <p>Tax: +1400</p>
          <h3>Total: 7876</h3>
        </div>
       
        <button className="checkout-button">Proceed to checkout</button>
        <button className="continue-shopping">Continue shopping</button>
      </div>
    </div>
  );
};

export default CartPage;
